module.exports = __webpack_public_path__ + "static/media/29BDOS7.c0957f15.jpg";